<template>
  <div id="services" class="sec">
    <div class="MyContainer-fluid">
      <div class="title-center">
        <h1>BIENVENIDO A OVERLAB INGENIERÍA SAS</h1>
      </div>

      <div class="container-fluid" style="background:var(--primary);">
        <div class="container" style="background:var(--back);">
          <h4 style="text-align: center;padding: 10px;">
            Nos ajustamos a las necesidades de nuestros clientes, desarrollando
            software,videojuegos y aplicaciones móviles a la medida.
          </h4>
          <div class="row d-flex align-items-start">
            <itemWelcome
              v-for="(item, i) in items"
              v-bind:key="i"
              :data="item"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import itemWelcome from "./itemWelcome";
export default {
  name: "welcome",
  components: {
    itemWelcome,
  },
  data() {
    return {
      items: [
        {
          ico: "house-door",
          title: "Desarrollo web",
          description: `Diseño web consiste en la creación de espacios especializados y
              creados a la medida, estos sitios promocionan y comunican de forma
              fácil, rápida y económica tanto a clientes como consumidores.`,
        },
        {
          ico: "cursor",
          title: "Aplicaciones con georreferenciación",
          description: `Aplicaciones móviles con georreferenciación.`,
        },
        {
          ico: "laptop",
          title: "Comercialización y distribución de equipos de computo",
          description: `Overlab S.A.S cuenta con una amplia variedad de sistemas de cómputo y accesorios, destinados a la satisfacción de las necesidades de las organizaciones que desean la adquisición de equipos a bajo costo y con amplia garantía.`,
        },
        {
          ico: "award",
          title: "Gobierno digital",
          description: `Marco de arquitectura empresarial, plan estratégico de tecnologías de la información y las comunicaciones.`,
        },
        {
          ico: "code-square",
          title: "Diseño y creación de software",
          description: `Software es el conjunto de programas, procedimientos, reglas, documentación y datos asociados que forman parte de las operaciones de un sistema de cómputo, elemento necesario para hacer posible la realización de las tareas específicas.`,
        },
        {
          ico: "controller",
          title: "Gamificación",
          description: `Estrategias de capacitación y reconocimiento de marca basadas en videojuegos y tecnología emergente (realidad virtual - realidad aumentada).`,
        },
        {
          ico: "file-earmark-text",
          title: "Aprovisionamiento de papelería",
          description: `Compra y venta de útiles y elementos de oficina y papelería.`,
        },
      ],
    };
  },
};
</script>

<style lang="css" scoped>
.MyContainer-fluid {
  height: auto;
  width: 100%;
}

.MyContainer {
  height: auto;
  width: 90%;
  margin: 0 5%;
}

.MyContainer-fluid .title-center {
  background: var(--accent);
  text-align: center;
  padding: 10px;
}

.MyContainer .title-center h1 {
  color: #fff;
}
</style>
